var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDismissSmall = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.89 3.64a.375.375 0 00-.53-.53L9 8.47 3.64 3.11a.375.375 0 00-.53.53L8.47 9l-5.36 5.36a.375.375 0 00.53.53L9 9.53l5.36 5.36a.375.375 0 00.53-.53L9.53 9l5.36-5.36z"
  })));
});
export default SvgDismissSmall;